import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from 'pinia'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

// Define CSS file links
const cssFiles = ["common", "auth"];
const devUrl = "sandbox-direct.tobecon.co.kr";
const prdUrl = "direct.tobecon.io";

const baseUrl =
    process.env.NODE_ENV === "production"
        ? `https://${window.location.host.includes("sandbox") ?
          devUrl : prdUrl}/res/css/` :
          `http://localhost:5232/res/css/`;

const loadCssFiles = cssFiles.map((file) => {
  return new Promise<void>((resolve, reject) => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = `${baseUrl}${file}/css/${file}.css`;
    link.onload = () => resolve();
    link.onerror = () => reject(new Error(`Failed to load CSS: ${file}`)); // 로드 실패 시 reject 호출
    document.head.appendChild(link);
  });
});

Promise.all(loadCssFiles)
  .then(() => {
    console.log("All CSS files loaded.");
    const pinia = createPinia();
    const app = createApp(App);

    app.use(router);
    app.use(pinia);
    app.component("VueDatePicker", VueDatePicker);
    app.mount("#app");
  })
  .catch((error) => {
    console.error("Error loading CSS files:", error);
    // Optional: You can still initialize the app even if CSS fails
    const pinia = createPinia();
    const app = createApp(App);

    app.use(router);
    app.use(pinia);
    app.component("VueDatePicker", VueDatePicker);
    app.mount("#app");
});